import React from "react";
import {  Navigate, Route, Routes } from "react-router";
import { authRoutes, privateRoutes } from "./router.link";
import Feature from "../feature";
import AuthFeature from "../authFeature";
import Error404 from "../pages/error-404/Error404";
import RouteTracker from "../../components/RouteTracker";

const ALLRoutes: React.FC = () => {  return (
    <>
      <RouteTracker />
      <Routes>
        <Route element={<AuthFeature />}>
          {authRoutes.map((route, idx) => (
            <Route path={route.path} element={route.element} key={idx} />
          ))}
        </Route>
     
          <>
            <Route path='/' element={ <Navigate to="/index" />}> </Route>
            <Route element={<Feature />}>
              {privateRoutes.map((route, idx) => (
                <Route path={route.path} element={route.element} key={idx} />
              ))}
            </Route>
            <Route path='*' element={<Error404/>}> </Route>           
          </>
        
        
      </Routes>
    </>
  );
};

export default ALLRoutes;
